import { render } from "./CustomerBank.vue?vue&type=template&id=6d7148b4"
import script from "./CustomerBank.vue?vue&type=script&lang=js"
export * from "./CustomerBank.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__